import styled from "styled-components";

export const Content = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	display: ${(props) => (props.setDisplay ? 'block' : 'none')};
`
export const ContentLogo = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 5px;
`
export const LogoName = styled.img`
	width: 10em;
`

export const Container = styled.div`
	display: flex;
	text-align: center;
	width: 100%;
	align-items: center;
	justify-content: center;
	margin-top: 5px;
`

export const Key = styled.div`
	height: 30%;
	text-align: center;
	font-size: 42px;
	line-height: 30px;
	font-weight: 700;
`

export const Unit = styled.div`
	width: 100%;
	text-align: center;
	font-size: 14px;
	font-weight: 600;
`

export const Attendance = styled.div`
	width: 100%;
	text-align: center;
	font-size: 14px;
	font-weight: 500;
`

export const Datetime = styled.div`
	width: 100%;
	text-align: center;
	font-size: 14px;
	font-weight: 500;
`

export const ContentQrCode = styled.div`
	width: 100%;
	height: 15%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 5px;
`
